import styled, { css } from 'styled-components'
import { Color, MediaBreakpoint } from 'root-constants'
import battery from 'assets/images/battery.png'

type TSubtitleProps = {
  color: string
}

type TIndicatorProps = {
  opacityValue: number
}

const commonTitleStyles = css`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
`

export const StyledEnergyLevel = {
  Wrapper: styled.div`
    max-width: 360px;
    margin: 0 auto;
  `,
  Title: styled.h2`
    ${commonTitleStyles};
    padding-bottom: 8px;
    color: ${Color.PRIMARY};
  `,
  Subtitle: styled.h2<TSubtitleProps>`
    ${commonTitleStyles};
    padding-bottom: 16px;
    color: ${({ color }) => color};
  `,
  BatteryContainer: styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    min-height: 190px;
    background-image: url(${battery});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  `,
  Battery: styled.img`
    position: absolute;
    top: 0;
    left: 0;
  `,
  IndicatorContainer: styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 210px;
    margin: 0 20px 22px 0;

    @media (min-width: ${MediaBreakpoint.MIN_PHONE}px) {
      width: 228px;
      margin: 0 20px 25px 0;
    }
  `,
  Indicator: styled.div<TIndicatorProps>`
    width: 32px;
    height: 92px;
    background-color: ${Color.WHITE};
    opacity: ${({ opacityValue }) => opacityValue};
    border-radius: 11px;

    @media (min-width: ${MediaBreakpoint.MIN_PHONE}px) {
      width: 35px;
    }
  `,
}
